//================================================================
//  Component: Cancel Approval Modal
//================================================================

//  Purpose: This modal will allow commercial managers to cancel their Approval

//  Properties:
//    - cancelRequestModal = {useState, used to store the current request and determine if the modal is visible}
//    - setCancelRequestModal = {useState, used to toggle the visibility of the cancel request modal}
//    - task = {object, used to store the current task}

//  Example:
//    <CancelRequestModal
//      cancelRequestModal={cancelRequestModal}
//      setCancelRequestModal={setCancelRequestModal}
//      task={task}
//    ></CancelRequestModal>

//================================================================

//Libraries
import React, { useState, useContext } from 'react';

//Contexts
import { GetUser } from '../../../../Library/GlobalContexts';

//Components

//Functions
import WriteDocument from '../../../../Library/WriteDocument';

//Images
import Error from '../../../../Components/Images/Icon_ErrorFatal_Red.svg';


export default function CancelApprovalModal({
  cancelRequestModal,
  setCancelRequestModal,
  task
}) {


  //------------------------------------------------------
  //  useContexts
  //------------------------------------------------------

  const getUser = useContext(GetUser);

  //------------------------------------------------------
  //  useStates
  //------------------------------------------------------

  // Used to set modal status > 'onload', 'error'
  const [modalStatus, setModalStatus] = useState('onload');

  // Used to store comment of the cancel request
  const [cancelRequestComment, setCancelRequestComment] = useState('');

  //------------------------------------------------------
  //  Functions
  //------------------------------------------------------

  // Used to cancel request
  function cancelRequest() {

    const updatedApprovalTask = {
      'status': 'Cancelled',
      'cancellationreason': cancelRequestComment,
      'lastmodifieddate': new Date(),
      'lastmodifiedby': {
        'email': getUser?.emailaddress,
        'givenname': getUser?.givenname,
        'surname': getUser?.surname
      },
      'activityfeed': task?.activityfeed
    }

    // Update the activity feed
    updatedApprovalTask.activityfeed.push({
      'activitydate': new Date(),
      'actionedby': {
        'email': getUser?.emailaddress,
        'givenname': getUser?.givenname,
        'surname': getUser?.surname
      },
      'action': 'cancelled',
      'comments': cancelRequestComment,
    })

    return WriteDocument('requests', task?.requestid, updatedApprovalTask, true)
      .then(() => {

        // Close Modal
        setCancelRequestModal(undefined);
        setCancelRequestComment('');

      })
      .catch((error) => {

        console.log(error);
        setModalStatus('error');

      })

  }

  //------------------------------------------------------
  //  HTML
  //------------------------------------------------------

  if (cancelRequestModal === undefined || cancelRequestModal === false) return null;

  // ---------------------------------------------------
  //  Onload
  // ---------------------------------------------------

  if (modalStatus === 'onload') {
    return (
      <div className='Modal-Background'>

        {/* Modal Container */}
        <dialog className='Warning-Modal-Container w-[650px] p-0'>

          {/* Header */}
          <div className='flex flex-row items-center px-4 py-[20px] border-b-[1px] border-b-[#D8D8D8]'>
            <h4 className='m-0'>Cancel Approval</h4>
          </div>

          {/* Body */}
          <div className='flex flex-col gap-[20px] px-4 pt-[5px]'>

            {/* Comment */}
            <div className='flex flex-col gap-3'>
              <label className='font-semibold'> Comment: <span className='text-[#C4314B]'>*</span> </label>
              <textarea
                className='Input-Field-TextArea mb-2'
                placeholder='Enter a reason for cancelling this approval'
                value={cancelRequestComment}
                onChange={(e) => setCancelRequestComment(e.target.value)}
              ></textarea>
            </div>

          </div>

          {/* Buttons */}
          <div className='flex flex-row items-center gap-2 py-3 px-4 border-t-[1px] border-t-[#D8D8D8]'>

            {/* Cancel Request */}
            <button
              disabled={cancelRequestComment.trim() === ''}
              className='Warning-Button'
              onClick={() => cancelRequest()}
            >
              Cancel Approval
            </button>

            {/* Cancel */}
            <button
              className='Secondary-Button'
              style={{ color: '#424242', border: '1px solid #424242' }}
              onClick={() => setCancelRequestModal(undefined)}
            >
              Cancel
            </button>

          </div>

        </dialog>
      </div>
    )
  }

  // ---------------------------------------------------
  //  Error
  // ---------------------------------------------------


  else if (modalStatus === 'error') {
    return (
      <div className='Modal-Background'>

        {/* Modal Container */}
        <dialog className='Warning-Modal-Container justify-center items-center'>

          <img className='my-1 w-[50px]' src={Error} alt='Error'></img>
          <h4 className='mb-0'>Oops! Something went wrong.</h4>

          <p className='text-center leading-[1.7]'>
            An error occurred while we processed your request.
          </p>

          <button
            className='Warning-Button'
            onClick={() => {
              setModalStatus('onload');
              setCancelRequestModal(undefined);
            }}
          >
            Close
          </button>

        </dialog>

      </div>
    )
  }

  //------------------------------------------------------
}
